import { render } from "./DialogPropsCmp.vue?vue&type=template&id=21b540ac"
import script from "./DialogPropsCmp.vue?vue&type=script&lang=js"
export * from "./DialogPropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__